import React, { useRef } from 'react';
import { Layout } from 'antd';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import usePageLayout from '../../hooks/usePageLayout';
import WiwHeaderTitle from '../../components/WiwHeaderTitle';
import artwork from './404.png';
import url from '../../utils/url';
import './index.scss';

const { Header, Content } = Layout;

export default function Page404() {
  const headerRef = useRef(null);
  const { contentHeight, contentTop } = usePageLayout(headerRef);
  const { t } = useTranslation('brand');
  return (
    <Layout className="app-layout page-not-found">
      <Helmet><title>404 — WIW</title></Helmet>
      <Header className="header" ref={headerRef}><WiwHeaderTitle title={t('back')} /></Header>
      <Content className="content-layot" style={{ height: contentHeight, top: contentTop }}>
        <div className="not-found-message">
          <img className="not-found-artwork" src={artwork} alt="404" width="364" height="167" />
          <p>{t('notFoundBody')}</p>
          <Link to={url('/')} className="not-found-feed">{t('backToFeed')}</Link>
        </div>
      </Content>
    </Layout>
  );
}
